Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _partialRight2=require("lodash/partialRight");var _partialRight3=_interopRequireDefault(_partialRight2);var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

VictorySharedEvents=function(_React$Component){_inherits(VictorySharedEvents,_React$Component);





































function VictorySharedEvents(){_classCallCheck(this,VictorySharedEvents);var _this=_possibleConstructorReturn(this,(VictorySharedEvents.__proto__||Object.getPrototypeOf(VictorySharedEvents)).call(this));

_this.state=_this.state||{};
_this.getScopedEvents=_index.Events.getScopedEvents.bind(_this);
_this.getEventState=_index.Events.getEventState.bind(_this);return _this;
}_createClass(VictorySharedEvents,[{key:"componentWillMount",value:function componentWillMount()

{
this.setUpChildren(this.props);
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(

newProps){
this.setUpChildren(newProps);
}},{key:"getAllEvents",value:function getAllEvents(

props){
var components=["container","groupComponent"];
this.componentEvents=_index.Events.getComponentEvents(props,components);
if(Array.isArray(this.componentEvents)){var _componentEvents;
return Array.isArray(props.events)?
(_componentEvents=this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):this.componentEvents;
}
return props.events;
}},{key:"setUpChildren",value:function setUpChildren(

props){
this.events=this.getAllEvents(props);
if(this.events){
this.childComponents=_react2.default.Children.toArray(props.children);
var childBaseProps=this.getBasePropsFromChildren(this.childComponents);
var parentBaseProps=props.container?props.container.props:{};
this.baseProps=(0,_assign3.default)({},childBaseProps,{parent:parentBaseProps});
}
}},{key:"getBasePropsFromChildren",value:function getBasePropsFromChildren(

childComponents){
var getBaseProps=function getBaseProps(children,childIndex){
return children.reduce(function(memo,child,index){
if(child.props&&child.props.children){
return getBaseProps(_react2.default.Children.toArray(child.props.children),index);
}else if(child.type&&(0,_isFunction3.default)(child.type.getBaseProps)){
var baseChildProps=child.props&&child.type.getBaseProps(child.props);
if(baseChildProps){
var key=childIndex?childIndex+"-"+index:index;
var childKey=child.props.name||key;
memo[childKey]=baseChildProps;
return memo;
}
return memo;
}
return memo;
},{});
};
return getBaseProps(childComponents);
}},{key:"getNewChildren",value:function getNewChildren(

props){var _this2=this;var
events=props.events,eventKey=props.eventKey;
var childNames=Object.keys(this.baseProps);
var alterChildren=function alterChildren(children){
return children.reduce(function(memo,child,index){
if(child.type&&(0,_isFunction3.default)(child.type.getBaseProps)){var _ret=function(){
var name=child.props.name||childNames.shift()||index;
var childEvents=Array.isArray(events)&&
events.filter(function(event){
if(event.target==="parent"){
return false;
}
return Array.isArray(event.childName)?
event.childName.indexOf(name)>-1:
event.childName===name||event.childName==="all";
});
var sharedEvents={
events:childEvents,
getEvents:(0,_partialRight3.default)(_this2.getScopedEvents,name,_this2.baseProps),
getEventState:(0,_partialRight3.default)(_this2.getEventState,name)};

return{v:memo.concat(_react2.default.cloneElement(child,(0,_assign3.default)(
{key:"events-"+name,sharedEvents:sharedEvents,eventKey:eventKey},
child.props)))};}();if(typeof _ret==="object")return _ret.v;

}else if(child.props.children){
return memo.concat(_react2.default.cloneElement(
child,
child.props,
alterChildren(_react2.default.Children.toArray(child.props.children))));

}else{
return memo.concat(child);
}
},[]);
};

return alterChildren(this.childComponents);
}},{key:"getContainer",value:function getContainer(

props,children){
var parents=Array.isArray(this.events)&&
this.events.filter(function(event){return event.target==="parent";});
var sharedEvents=parents.length>0?
{
events:parents,
getEvents:(0,_partialRight3.default)(this.getScopedEvents,null,this.baseProps),
getEventState:(0,_partialRight3.default)(this.getEventState,null)}:
null;
var container=this.props.container||this.props.groupComponent;
var boundGetEvents=_index.Events.getEvents.bind(this);
var parentEvents=sharedEvents&&boundGetEvents({sharedEvents:sharedEvents},"parent");
var parentProps=(0,_defaults3.default)(
{},
this.getEventState("parent","parent"),
container.props,
this.baseProps.parent,
{children:children});

return _react2.default.cloneElement(
container,
(0,_assign3.default)(
{},parentProps,{events:_index.Events.getPartialEvents(parentEvents,"parent",parentProps)}));


}},{key:"render",value:function render()

{
if(this.events){
var children=this.getNewChildren(this.props);
return this.getContainer(this.props,children);
}
return _react2.default.cloneElement(this.props.container,{children:this.props.children});
}}]);return VictorySharedEvents;}(_react2.default.Component);VictorySharedEvents.displayName="VictorySharedEvents";VictorySharedEvents.role="shared-event-wrapper";VictorySharedEvents.propTypes={children:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node),_react2.default.PropTypes.node]),container:_react2.default.PropTypes.node,groupComponent:_react2.default.PropTypes.node,events:_react.PropTypes.arrayOf(_react.PropTypes.shape({childName:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.array]),target:_react.PropTypes.string,eventKey:_react.PropTypes.oneOfType([_react.PropTypes.array,_react.PropTypes.func,_index.PropTypes.allOfType([_index.PropTypes.integer,_index.PropTypes.nonNegative]),_react.PropTypes.string]),eventHandlers:_react.PropTypes.object})),eventKey:_react.PropTypes.oneOfType([_react.PropTypes.array,_react.PropTypes.func,_index.PropTypes.allOfType([_index.PropTypes.integer,_index.PropTypes.nonNegative]),_react.PropTypes.string])};VictorySharedEvents.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=VictorySharedEvents;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-shared-events/victory-shared-events.js
// module id = 1274
// module chunks = 0 1